import { Injectable } from '@angular/core';
import { IAnnualReportTemplateDTO } from '@modeso/aumico-lib-annualreport-fe';
import { AnnualReportTemplate } from '@modeso/types__aumico-lib-annualreport-be';

@Injectable({
    providedIn: 'root',
})
export class AnnualReportTemplateMapper {
    mapIAnnualReportTemplateDTOToAnnualReportTemplate(
        arTemplateDto: IAnnualReportTemplateDTO | null,
    ): AnnualReportTemplate | null {
        if (arTemplateDto == null) {
            return null;
        }
        return {
            _id: arTemplateDto.id,
            name: arTemplateDto.name,
            caption: arTemplateDto.caption,
            annualReportSteps: arTemplateDto.annualReportSteps,
            balanceTaxonomyId: arTemplateDto.balanceTaxonomyId,
            incomeTaxonomyId: arTemplateDto.incomeTaxonomyId,
            notesTemplateId: arTemplateDto.notesTemplateId,
            reportingTemplateId: arTemplateDto.reportingTemplateId,
            legalFormsIds: arTemplateDto.legalFormsIds,
            accountingBasesIds: arTemplateDto.accountingBasesIds,
            countryISO31661Alpha2Codes: arTemplateDto.countryISO31661Alpha2Codes,
            state: arTemplateDto.state,
            consistency: arTemplateDto.consistency,
            businessModel: arTemplateDto.businessModel,
            settings: arTemplateDto.settings,
            locales: arTemplateDto.locales,
        };
    }

    mapAnnualReportTemplateToIAnnualReportTemplateDTO(arTemplate: AnnualReportTemplate): IAnnualReportTemplateDTO {
        return {
            id: arTemplate._id,
            name: arTemplate.name,
            caption: arTemplate.caption,
            annualReportSteps: arTemplate.annualReportSteps,
            balanceTaxonomyId: arTemplate.balanceTaxonomyId,
            incomeTaxonomyId: arTemplate.incomeTaxonomyId,
            notesTemplateId: arTemplate.notesTemplateId,
            reportingTemplateId: arTemplate.reportingTemplateId,
            legalFormsIds: arTemplate.legalFormsIds,
            accountingBasesIds: arTemplate.accountingBasesIds,
            countryISO31661Alpha2Codes: arTemplate.countryISO31661Alpha2Codes,
            state: arTemplate.state,
            consistency: arTemplate.consistency,
            businessModel: arTemplate.businessModel,
            settings: arTemplate.settings,
            locales: arTemplate.locales,
        };
    }
}
